module.exports = __webpack_public_path__ + "BJ.png?7bd9d4c0149f2a0d740a4a7c542416f1";